// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0bb5fe25","455":"f3ed6f67","977":"a78bfa2d"}[chunkId] + ".chunk.js";
};